var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cs-center-wrapper"},[_c('cs-center-header'),_c('main',{staticClass:"cs-center-content"},[_c('cs-center-nav',{on:{"active":_vm.onActive}}),_c('section',{staticClass:"cs-center-section"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }